import { COMPANY_NAME } from './constants';

// const API_BASE_URL = 'https://envdev3456785456.stragilia.com';
const API_BASE_URL = 'https://app.stragilia.com';
const USER_AGENT = `${COMPANY_NAME.replace(/\s+/g, '')}APIClient`;

class APIClient {
  constructor() {
    this.baseURL = API_BASE_URL;
    this.userAgent = USER_AGENT;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;

    const headers = {
      'Content-Type': 'application/json',
      'X-Client-Name': this.userAgent,
      ...options.headers,
    };

    try {
      const response = await fetch(url, {
        ...options,
        headers,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  async fetchPlans() {
    return this.request('/api.php?fetchPlans=1', {
      method: 'GET',
    });
  }

  async sendContactForm(formData) {
    const url = `${this.baseURL}/api.php`;

    const body = new URLSearchParams({
      name: formData.name,
      email: formData.email,
      telephone: formData.phone,
      company_name: formData.company,
      message: formData.message,
      subject: formData.subject,
      sendContactForm: '1',
    });

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Client-Name': this.userAgent,
        },
        body: body.toString(),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error: data.error || `HTTP error! status: ${response.status}`,
          status: response.status,
        };
      }

      return data;
    } catch (error) {
      console.error('Contact form submission failed:', error);
      return {
        success: false,
        error: error.message || 'Network error occurred',
      };
    }
  }

  async sendCareerForm(formData) {
    const url = `${this.baseURL}/api.php`;

    const body = new URLSearchParams({
      application_type: formData.application_type,
      full_name: formData.full_name,
      email: formData.email,
      phone: formData.phone,
      target_role: formData.target_role || '',
      job_reference: formData.job_reference || '',
      linkedin_profile: formData.linkedin_profile,
      cv_link: formData.cv_link,
      sendCareerForm: '1',
    });

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Client-Name': this.userAgent,
        },
        body: body.toString(),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error: data.error || `HTTP error! status: ${response.status}`,
          status: response.status,
        };
      }

      return data;
    } catch (error) {
      console.error('Career form submission failed:', error);
      return {
        success: false,
        error: error.message || 'Network error occurred',
      };
    }
  }

  async createChatSession(formData) {
    const url = `${this.baseURL}/api.php`;

    const body = new URLSearchParams({
      create_homepage_chat_session: '1',
      name: formData.name,
      email: formData.email,
      phone: formData.contact,
    });

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Client-Name': this.userAgent,
        },
        body: body.toString(),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        return {
          success: false,
          error: data.message || `HTTP error! status: ${response.status}`,
        };
      }

      return data;
    } catch (error) {
      console.error('Chat session creation failed:', error);
      return {
        success: false,
        error: error.message || 'Network error occurred',
      };
    }
  }

  async sendChatMessage(sessionId, message) {
    const url = `${this.baseURL}/api.php`;

    const body = new URLSearchParams({
      homepage_chat: '1',
      session_id: sessionId,
      message: message,
    });

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Client-Name': this.userAgent,
        },
        body: body.toString(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response;
    } catch (error) {
      console.error('Chat message failed:', error);
      throw error;
    }
  }
}

export const apiClient = new APIClient();
